import {Link} from "react-router-dom";

export default function MainBlockNews(props) {
    return (
        <section className="main_block main_block_news">
            <div className="container">
                <div className="bread_crumbs">
                    <div>
                        <Link to="/">Главная</Link>
                    </div>
                    <div>></div>
                    <div>Новости</div>
                </div>
                <h1>
                    <span className="title main_title">пресс-центр</span>
                </h1>
            </div>
        </section>
    )
}
